import { render, staticRenderFns } from "./template-config.vue?vue&type=template&id=0009ef95"
import script from "./template-config.vue?vue&type=script&lang=ts"
export * from "./template-config.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports